import React, { useState, useEffect } from "react";
import authCss from "./Auth.module.css";
import MenuBar from "../UI/Menu/Menu";
import Blob from "../UI/Blob/Blob";
import bubbleBgAuthImg from "../../images/bubblebg-auth.jpg";
import { Input } from "../UI/Input/Input";
import { ButtonSubmitBlack } from "../UI/Buttons/Buttons";
import Button from "../UI/Buttons/Button";
import bubbleBannerBg from "../../images/bubblebannerbg.png";
import { Send} from '@mui/icons-material';
import axios from 'axios';
import { ThreeCircles } from 'react-loader-spinner';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LoopIcon from '@mui/icons-material/Loop';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import SchoolIcon from '@mui/icons-material/School';
import { FaLongArrowAltRight } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom';
import { useErrorSetter } from '../../hooks/useUiMessages';



const screenWidth = window.innerWidth

const Verification = () => {
    const { email } = useSelector(state => state.stateData)
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        email: email || "",
        code: ""
    });
    const [verified, setVerified] = useState(false);
    const [count, setCount] = useState(60);
    const [isZero, setIsZero] = useState(false);
    const [firstName, setFirstName] = useState("")

    const errorSetter = useErrorSetter();

    //If email is not set for verification
    useEffect(() => {

        if (email === "" && location.search.slice(6) === "") {
            navigate('/join-bubble')
        } 
        if (location.search.slice(6) !== "") {
            setData(prev => ({
                ...prev,
                email: location.search.slice(6)
            }))
        }
    }, [navigate, location, email]);

    //set email verification countdown
    useEffect(() => {
        if (count > 0) {
          const timer = setTimeout(() => setCount(count - 1), 1000);
          return () => clearTimeout(timer);
        } else {
          setIsZero(true);
        }
    }, [count]);

    const handleFormSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        try {
            const response = await axios.post('/auth/verify', data)
            setLoading(false)
            //check for predefined errors that might not be caught by error handler
            if (response.data.status === "error") {
                errorSetter(response.data.message)
                return
            }
            
            setFirstName(response.data.firstName)

            // Persist trial outcome for post-verify message rendering
            const trial = response.data.trial;
            window.sessionStorage.setItem('trialOutcome', trial?.outcome || 'unknown');
            setVerified(true)
            

            //FOR TRACKING REGISTRATION ON A DEVICE BROWSER
            localStorage.setItem('isRegUse6aghajghdjfja', 'true');
            localStorage.setItem('isRegEm6aghajghdjfja', data.email);

        } catch (error) {
            setLoading(false)
            if (error?.response?.data?.message === "User already verified") {
                navigate("/popin")
            }
            errorSetter(error?.response?.data?.message)
        }

    }

    const handleReset = async () => {
        setCount(60);
        setIsZero(false);
        //send email resend request
        try {
            const response = await axios.post('/auth/resend-email-code', data)
            console.log(response);
        } catch (error) {
            errorSetter(error.response.data.message)
        }
    };

    const handleInputChange = (prop) => (event) => {
        setData({ ...data, [prop]: event.target.value});
    };
    return (
        <div>
            <MenuBar />
            <div className={authCss.authContainer}>

                <div style={{marginBottom: screenWidth > 900 ? '350px' : '', marginRight: '100px'}}>
                    <Blob bgImage={bubbleBgAuthImg} altText="Verify" />
                </div>

                <div style={{marginTop: screenWidth > 900 ? '350px' : '', marginLeft: '100px'}} >
                    <Blob bgImage={bubbleBgAuthImg} altText="Verify" />
                </div>

            </div>

            <div className={authCss.formContainer}>
                <div className={authCss.formInner}>
                    {!verified ? (
                        <div>
                            <h2>Verify Email</h2>
                            <span>Verification code sent to email below</span>
                            <div style={{fontSize: '.8rem', color: '#56A8AC', marginBottom: '10px'}}>{data.email}</div>
                                <div style={{margin: '10px 0', fontSize: '.8rem'}}>
                                    <p style={{textAlign: "center"}}>Didn't receive a code? <strong>Check spam</strong></p>
                                    <span>
                                        <button disabled={!isZero} className={isZero ? authCss.enabledResendBtn :  authCss.disabledResendBtn} onClick={handleReset}>Resend</button>
                                        {!isZero && <span>code in <span style={{backgroundColor: '#c0d1d453', padding: '3px', borderRadius: '5px', color: '#3E8F93'}}>{count}</span> seconds</span>}
                                    </span> 
                                </div>
                            <form onSubmit={handleFormSubmit}>

                                <Input placeholder="Verification Code" value={data.code} inputType="password" inputGridSm={12} onChange={handleInputChange('code')} required />
                                <div>
                                    <ButtonSubmitBlack type="submit">{!loading ? <Send /> : 
                                        <ThreeCircles
                                            height="25"
                                            width="25"
                                            color="#FFFFFF"
                                            visible={true}
                                            ariaLabel="three-circles-rotating"
                                        />}
                                    </ButtonSubmitBlack>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <div>
                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#56A8AC'}} >
                                <CheckCircleIcon fontSize="large" /> 
                                <h2>Account Verified</h2>
                            </div>
                            <div style={{
                                width: '100%',
                                boxSizing: 'border-box',
                                padding: '18px 16px',
                                borderRadius: '14px',
                                color: '#0b2e30',
                                backgroundImage: `linear-gradient(to right, rgba(111,203,209,0.4), rgba(57,104,107,0.85)), url(${bubbleBannerBg})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                boxShadow: 'inset 8px 8px 16px rgba(0,0,0,0.08)'
                            }}>
                                <div style={{ textAlign: 'center', color: '#fff' }}>
                                    <div style={{ fontSize: '1.05rem', fontWeight: 700, marginBottom: 6 }}>
                                        🎉 Welcome to Bubble Ai, {firstName || 'there'}! Your account is verified.
                                    </div>
                                    <div style={{ fontSize: '.95rem', fontWeight: 600, color: '#F8E231', marginBottom: 10 }}>
                                        💡 Special New User Offer — 60% OFF today only!
                                    </div>
                                </div>

                                <div style={{
                                    background: 'rgba(255,255,255,0.95)',
                                    color: '#264d50',
                                    borderRadius: 12,
                                    padding: '12px 14px',
                                    margin: '10px auto',
                                    maxWidth: 640
                                }}>
                                    <h3>Bubble Ai will:</h3>
                                    <ul style={{ listStyle: 'none', padding: 0, margin: 0, lineHeight: 1.8, fontSize: '.9rem' }}>
                                        <li style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <LoopIcon sx={{ fontSize: 18, color: '#3E8F93' }} />
                                            Apply to jobs for you
                                        </li>
                                        <li style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <AutoFixHighIcon sx={{ fontSize: 18, color: '#3E8F93' }} />
                                            Optimize resumes & cover letters for each job
                                        </li>
                                        <li style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <SchoolIcon sx={{ fontSize: 18, color: 'rgb(62, 143, 147)' }} />
                                            Get 80%+ exam score with 20% or less work
                                        </li>
                                    </ul>
                                    <p style={{ marginTop: 10, fontSize: '.9rem' }}>
                                        👉 Most users upgrade when they want a job fast! Get full access to the <strong>Pro Month</strong> or <strong>Pro</strong> plan for 60% OFF <strong>(today only)</strong>.
                                    </p>
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: 12, gap: 12 }}>
                                        <Button
                                            primary
                                            link="/#pricing"
                                            title="View 60% OFF"
                                        >
                                            <span style={{ marginLeft: 6 }}><FaLongArrowAltRight /></span>
                                        </Button>
                                        <Button
                                            secondaryLight
                                            link="/user/dashboard/resume"
                                            title="Create/Optimize my resume"
                                            color="#3E8F93"
                                            $border={`.1rem solid #3E8F93`}
                                        />
                                        <Button
                                            secondaryLight
                                            link="/user/dashboard/mock"
                                            title="Write mock exam"
                                            color="#3E8F93"
                                            $border={`.1rem solid #3E8F93`}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>        
    )
}

export default Verification;